import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import NotFoundPage from 'pages/public/NotFoundPage';

import CashCreditLists from './CashCreditList';
import CashCreditShow from './CashCreditShow';

const CashCredit = () => {
  return (
    <Routes>
      <Route index element={<Navigate to="list" replace />} />
      <Route path="list" element={<CashCreditLists />} />
      <Route path="show/:id" element={<CashCreditShow />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default CashCredit;
